import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { RHFTextField } from "src/components/hook-form";
import RHFDatePicker from "src/components/hook-form/RHFDatePicker";
import RHFRadioGroups from "src/components/hook-form/RHFRadioGroups";
import RHFSelector from "src/components/hook-form/RHFSelector";
import Iconify from "src/components/Iconify";
import ProvinceSelector from "src/components/selector/Province";
import { DUTY_DEFAULT_OP, GENDER_DEFAULT_OP, PASSPORT_DEFAULT_OP } from "src/config";
import UniversitySelector from "src/pages/university/selector";
import universityCategorySelector from 'src/pages/universityCategory/selector';
import { timeIsAfterToday } from "src/utils/formatTime";


const HamrahSection = ({
    index,
}) => {
    const queryParams = useParams();
    const { id, travel } = queryParams;

    const admin = useSelector((store) => store.admin.data);

    const { watch, getValues } = useFormContext();
    const travelMainObj = useSelector((store) => store.travel.data);
    const [TravelDataFromStore, setTravelDataFromStore] = useState({})
    const [DisableInputs, setDisableInputs] = useState(false)

    // const genderWatcher = watch(`companions[${index}].gender`);
    // const studentWatcher = watch(`companions[${index}].is_Student`);
    const genderWatcher = useWatch({ name: `companions[${index}].gender` });
    const studentWatcher = useWatch({ name: `companions[${index}].is_Student` });

    const handleCheckUserCanEditInputs = (inputLabel = "") => {
        // console.log({inputLabel , admin})
        if(admin?.has_won_lottery == 6){
            if(
                inputLabel === "کدملی" ||
                inputLabel === "تلفن همراه" 
            ){
                setDisableInputs(true)
                return true
            }
            if(admin?.add_by_admin){
                if(TravelDataFromStore?.type_finish_at && timeIsAfterToday(TravelDataFromStore?.type_finish_at)){
                    setDisableInputs(true)
                    return true
                }
                setDisableInputs(false)
                return false
            }
            setDisableInputs(true)
            return true
        }
        if(
            inputLabel === "کدملی" ||
            inputLabel === "تلفن همراه" 
        ){
            if(admin?.id){
                setDisableInputs(true)
                return true
            }
        }
        setDisableInputs(false)
        return false
    }

    const hamrahStage = index === 0 ? "همسر" : `فرزند ${index}`;

    useEffect(() => {
        if(Object.values(travelMainObj)?.length > 0){
            Object.values(travelMainObj).forEach((value , index) => {
                const selectedTravel = value?.find(item => item?.id == travel)
                // console.log({setTravelDataFromStore : selectedTravel})
                if(selectedTravel){
                    setTravelDataFromStore(selectedTravel)
                }
            })
        }
    }, [travelMainObj])

    useEffect(() => {
        if(admin?.id && TravelDataFromStore){
            // handleCheckUserCanEditInputs()
        }
    }, [admin, TravelDataFromStore])

    return (
        <>
            <Box sx={{
                px: 3,
            }}>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: 2,
                        backgroundColor: 'grey.main',
                        borderRadius: '8px',
                        mb: 4
                    }}
                >
                    <Typography>اطلاعات {hamrahStage}</Typography>

                </Box>
                <Grid sx={{}} container spacing={3}>

                    <Grid item xs="12" md={6}>
                        <RHFTextField
                            name={`companions[${index}].name`}
                            label={"نام " + hamrahStage}
                            required
                            disabled={DisableInputs}
                        />
                    </Grid>
                    <Grid item xs="12" md={6}>
                        <RHFTextField
                            name={`companions[${index}].last_name`}
                            label={"نام خانوادگی " + hamrahStage}
                            required
                            disabled={DisableInputs}
                        />
                    </Grid>
                    
                    <Grid item xs="12" md={6}>
                        <RHFTextField
                            name={`companions[${index}].father_name`}
                            label={"نام پدر " + hamrahStage}
                            required
                            disabled={DisableInputs}
                        />
                    </Grid>
                    <Grid item xs="12" md={6}>
                        <RHFDatePicker
                            name={`companions[${index}].birthDate`}
                            label={`تاریخ تولد ${hamrahStage}`}
                            pickerProps={{
                                maxDate: new Date(),
                            }}
                            required
                            disabled={DisableInputs}
                        />
                    </Grid>

                </Grid>
            </Box>
        </>
    );
}

export default HamrahSection;